import { query_plan_info_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model/mjstore/mjstore-planinfo-config';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { reactive } from 'vue';
import { getDateTime } from '@/utils/function';
const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const None = null;
const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: !!current_shop,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    customer_id: null,
    shop_id: current_shop?.id,
  }),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const update_model_config_options = {};

const titleList = {
  title: '计划',
  addModalTitle: '新建撤单',
  updateTitle: '修改撤单',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '诉求号',
    width: 170,
    dataIndex: 'require_info__code',
    checked: true,
  },
  {
    title: '会员编号',
    width: 150,
    dataIndex: 'customer__code',
    checked: true,
  },
  {
    title: '会员姓名',
    width: 150,
    dataIndex: 'customer__name',
    checked: true,
  },
  {
    title: '计划日期',
    width: 150,
    dataIndex: 'date',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '计划项目',
    width: 150,
    dataIndex: 'project',
    checked: true,
  },
  {
    title: '计划数量',
    width: 150,
    dataIndex: 'num',
    checked: true,
  },
  {
    title: '执行门店',
    width: 150,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '操作',
    width: 60,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_plan_info_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
